import { useEffect, useState } from "react";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";
import Select from "../../../../components/Select";
import { JobRoleDetailService } from "../../../../services/JobRoleDetailService";

export default function TechAreaInterest() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  const [candidateInterestTechRoles, setCandidateInterestTechRoles] = useState([]);
  const [candidateInteresrtTechAreas, setCandidateInterestTechAreas] = useState([]);

  useEffect(() => {
    getTechAreas();
  }, []);

  function getTechAreas() {
    JobRoleDetailService.getAllTechAreas().then((data) => {
      setCandidateInterestTechAreas(data);
    });
  }
  function getTechRoles(techAreaId) {
    JobRoleDetailService.getAllTechRoles(techAreaId).then((data) => {
      setCandidateInterestTechRoles(data);
    });
  }

  useEffect(() => {
    if (searchObject?.candidateInterestTechAreaId)
      getTechRoles(searchObject.candidateInterestTechAreaId);
  }, [searchObject?.candidateInterestTechAreaId]);
  
  return (
    <fieldset>
      <legend>{t("Tech Area Interest / Tech Role Interest")}</legend>
        <div className="col mb-2">
            <label className="form-label">{t("Tech Area Interest")}</label>
            <Select
                className="form-select fontsize-legend"
                name="candidateInterestTechAreaId"
                id="candidateInterestTechAreaId"
                onChange={onChange}
                value={searchObject.candidateInterestTechAreaId || ""}
            >
                <option></option>
                {candidateInteresrtTechAreas?.map((candidateInteresrtTechArea) => (
                <option className="fontsize-legend" key={candidateInteresrtTechArea.id} value={candidateInteresrtTechArea.id}>
                    {t(candidateInteresrtTechArea.description)}
                </option>
                ))}
            </Select>
        </div>
        <div className="col" style={{marginTop:"20px"}}>
            <label className="form-label">{t("Tech Role Interest")}</label>
            <Select
            className="form-select fontsize-legend"
            name="candidateInterestTechRoleId"
            id="candidateInterestTechRoleId"
            onChange={onChange}
            value={searchObject.candidateInterestTechRoleId || ""}
            >
            <option></option>
            {candidateInterestTechRoles?.map((candidateInterestTechRole) => (
                <option className="fontsize-legend" key={candidateInterestTechRole.id} value={candidateInterestTechRole.id}>
                {t(candidateInterestTechRole.description)}
                </option>
            ))}
            </Select>
        </div>
    </fieldset>
  );
}
